<cm-card>
  <cm-text appearance="emphasis" slot="header"
    >{{ baseUrl }}{{ orgUuid }}</cm-text
  >
  <pre><code>{{ data }}</code></pre>
</cm-card>
